module.exports = __webpack_public_path__ + "img/pic_413861.8acf209d.jpg";